import { Box, Grid } from '@mui/material';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IWorkspace, updateWorkspace } from 'wisestep-api';
import { WsButton, WsColors, WsTypography } from 'wisestep-base';

import { ActivateFeature } from '../../../../components/ActivateFeature';
import WsCheckBox from '../../../../components/WsCheckBox/WsCheckBox';
import { useWorkspaceContext } from '../../../../context/WorkspaceContext';
import { failed, success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import RecruiterProfileDetails from '../../RecruiterProfileDetails';

const MfaAuthenticatorLayout = () => {
  const workspace = useWorkspaceContext();
  const setNotification = useNotificationStore((state) => state.setNotification);
  const workspaceDetailsDefaultValues = {
    requiresMFA: workspace?.requiresMFA,
  };
  const formOptions = {
    defaultValues: workspaceDetailsDefaultValues,
  };
  const methods = useForm<IWorkspace>(formOptions);
  const { handleSubmit, reset } = methods;
  const onFormSubmit = async (data: IWorkspace) => {
    const tempData = { ...workspace };
    if (tempData && data) {
      tempData.about = data.about;
      tempData.requiresMFA = data.requiresMFA;
      try {
        if (workspace.setWorkspace) {
          workspace.setWorkspace(tempData);
        }
        tempData.workspacePlan = null;
        await updateWorkspace(tempData);
        setNotification(success('Workspace details updated successfully!'));
      } catch (error) {
        setNotification(failed('Failed to save workspace details!'));
      }
    }
  };
  useEffect(
    () =>
      reset({
        requiresMFA: workspace?.requiresMFA,
      }),
    [workspace, reset]
  );
  return (
    <RecruiterProfileDetails title={'MFA Authenticator'}>
      <FormProvider {...methods}>
        <Box
          component="form"
          sx={{ backgroundColor: WsColors.White }}
          onSubmit={handleSubmit(onFormSubmit)}
        >
          <Grid container py={4} px={2}>
            <Grid item xs={9}>
              <WsTypography>
                Enhance your organisation&apos;s security by requiring your users to identify
                themselves by more than a Username and Password
              </WsTypography>
            </Grid>
            <Grid item xs={3} display="flex" justifyContent="right">
              <WsButton type="submit">Save</WsButton>
            </Grid>
            <Grid item mt={2}>
              <ActivateFeature feature="RS_WORKSPACE_MFA">
                <WsCheckBox name={'requiresMFA'} label={'Enable MFA for Users'} />
              </ActivateFeature>
            </Grid>
          </Grid>
        </Box>
      </FormProvider>
    </RecruiterProfileDetails>
  );
};
export default MfaAuthenticatorLayout;
